var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Dialog as MuiDialog, Grow, useTheme } from '@mui/material';
import { useCallback } from 'react';
import ModalTitleBar from './Modal.TitleBar';
var ChildrenPadding = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 16px 20px;\n"], ["\n  padding: 16px 20px;\n"])));
var Modal = function (_a) {
    var _b = _a.full, full = _b === void 0 ? false : _b, disableTransition = _a.disableTransition, _c = _a.allowCloseOnClickOutside, allowCloseOnClickOutside = _c === void 0 ? false : _c, children = _a.children, onClose = _a.onClose, open = _a.open, title = _a.title, _d = _a.noPadding, noPadding = _d === void 0 ? false : _d, _e = _a.resizable, resizable = _e === void 0 ? false : _e;
    var theme = useTheme();
    var onCloseModal = useCallback(function (e, reason) {
        if (onClose) {
            if (reason === 'backdropClick') {
                if (allowCloseOnClickOutside) {
                    onClose();
                }
            }
            else {
                onClose();
            }
        }
    }, [allowCloseOnClickOutside, onClose]);
    var paperStyles = {};
    if (resizable) {
        paperStyles.maxWidth = 'unset';
        paperStyles.minWidth = 'unset';
    }
    var transitionDuration = {
        appear: disableTransition ? 0 : theme.transitions.duration.enteringScreen,
        enter: disableTransition ? 0 : theme.transitions.duration.enteringScreen,
        exit: disableTransition ? 0 : theme.transitions.duration.leavingScreen
    };
    return (_jsxs(MuiDialog, __assign({ fullScreen: full, closeAfterTransition: true, onClose: onCloseModal, open: open, TransitionComponent: Grow, PaperProps: { sx: paperStyles }, transitionDuration: transitionDuration }, { children: [title && _jsx(ModalTitleBar, { title: title, onClose: onClose && onCloseModal }), noPadding ? children : _jsx(ChildrenPadding, { children: children })] })));
};
export default Modal;
var templateObject_1;
